<template>
    <div class="width payment_delete__container mb-3">
        <form method="POST">
            <div class="grid">
                <div class="col-12 flex flex-column justify-content-between gap-3">
                    <div class="card-form my-0">
                        <h3>{{ $t('lang.bill.bill_number', [bill.id]) }}</h3>
                        <div class="description" v-html="bill.fullDescriptionHtml"></div>
                        <!-- Тариф и пакеты отдельными суммами: скидки бьют только по тарифу -->
                        <div v-if="hasBreakdown" class="mt-3 flex flex-column gap-2">
                            <div class="flex justify-content-between align-items-center gap-3">
                                <span class="text-color-secondary">{{ $t('lang.bill.label_tariff_cost') }}</span>
                                <span class="font-bold">{{ bill.tariffPrice.formatMoney(0, ' ', ' ') }} {{ $t('lang.main.currency.sign') }}</span>
                            </div>
                            <div
                                v-for="(addon, index) in bill.addons"
                                :key="index"
                                class="flex justify-content-between align-items-center gap-3"
                            >
                                <div class="flex flex-column">
                                    <span class="text-color-secondary">{{ addon.label }}</span>
                                    <span class="text-sm text-color-secondary">
                                        {{ $t('lang.bill.label_addons_amount', [(addon.quantity * addon.packSize).formatMoney(0, ' ', ' ')]) }}
                                    </span>
                                </div>
                                <span class="font-bold">{{ addon.amount.formatMoney(0, ' ', ' ') }} {{ $t('lang.main.currency.sign') }}</span>
                            </div>
                        </div>
                        <div class="mt-3">
                            <div v-if="hasBreakdown" class="text-color-secondary">{{ $t('lang.bill.label_total') }}</div>
                            <div class="amount">{{ bill.realPrice.formatMoney(0, ' ', ' ') }} {{ $t('lang.main.currency.sign') }}</div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card-form my-0 h-full flex flex-column justify-content-between">
                        <p class="py-0">{{ $t('lang.bill.delete.message') }}</p>
                        <div class="flex justify-content-end">
                            <input type="hidden" name="act" value="deleteBill" />
                            <Button :label="$t('lang.bill.delete.button')" type="submit" />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Button from "primevue/button";

export default {
    name: "PaymentDelete",
    props: {
        bill: {
            type: Object,
            required: true,
        }
    },
    computed: {
        /** На счёте только за пакет строка одна и совпадает с итогом — разбивка не нужна */
        hasBreakdown() {
            return (this.bill.addons || []).length > 0 && !this.bill.isAddonsOnly;
        },
    },
    components: {
        Button,
    }
}
</script>

<style scoped>
.payment_delete__container {
    max-width: 600px;
}
.amount {
    font-weight: 800;
    font-size: 32px;
    line-height: 38px;
    color: #6AB110;
}
</style>
